import { Descriptions } from 'antd';
import React from 'react';
import CurrencyFormat from 'components/CurrencyFormat';
import { getCalculatedOrder } from 'shared/utils/order';
import { dayjs } from 'shared/utils/date';
import { DiscountType, PaymentStatus } from 'shared/prisma/types';

const ItemLabel = ({ item }) => {
  const { title, description, startDate, endDate } = item;
  const labels = [
    title,
    description,
    startDate && endDate && `${dayjs(startDate).format('MMM DD, YYYY')} - ${dayjs(endDate).format('MMM DD, YYYY')}`,
  ];
  return labels.filter(label => label).join(' - ');
};

const DiscountLabel = ({ discount }) => {
  const { title, description, amount, type } = discount;
  const labels = [
    title,
    description,
    type === DiscountType.Percentage && amount > 0 && `${amount}%`,
  ];
  return labels.filter(label => label).join(' - ');
};

const Order = ({ order, hidePeriod, hideDataSource }) => {
  const calculatedOrder = getCalculatedOrder(order);

  return (
    <Descriptions
      title={order.orderNumber ? `Order #${order.orderNumber}` : null}
      bordered
      column={1}
      size="small"
      styles={{ content: { whiteSpace: 'nowrap', textAlign: 'right' } }}
    >
      {!hideDataSource && order.dataSource && (
        <Descriptions.Item label={`Data source - ${order.dataSource}`} />
      )}
      {!hidePeriod && order.startDate && order.endDate && (
        <Descriptions.Item label={`Period - ${dayjs(order.startDate).format('MMM DD, YYYY')} - ${dayjs(order.endDate).format('MMM DD, YYYY')}`} />
      )}
      {order.amount > 0 && order.paymentDate && (
        <Descriptions.Item label={`Paid on - ${dayjs(order.paymentDate).format('MMM DD, YYYY')}`} />
      )}
      {order.amount > 0 && !order.paymentDate && order.paymentStatus === PaymentStatus.Pending && order.startDate && dayjs(order.startDate).isAfter(dayjs(), 'day') && (
        <Descriptions.Item label={`Will be paid on - ${dayjs(order.startDate).format('MMM DD, YYYY')}`} />
      )}
      {calculatedOrder.items.map((item, index) => (
        <Descriptions.Item key={index} label={<ItemLabel item={item} />}>
          {item.amount != null && <CurrencyFormat currency={order.currency} value={item.amount} />}
        </Descriptions.Item>
      ))}
      {calculatedOrder.subtotal != null && (
        <Descriptions.Item label={<b>Subtotal</b>}>
          <CurrencyFormat value={calculatedOrder.subtotal} currency={order.currency} />
        </Descriptions.Item>
      )}
      {calculatedOrder.discounts.map((discount, index) => (
        <Descriptions.Item key={index} label={<DiscountLabel discount={discount} />}>
          <CurrencyFormat value={-discount.calculatedAmount} currency={order.currency} />
        </Descriptions.Item>
      ))}
      {order.monthlyAmount && (
        <Descriptions.Item label={<b>Total / month</b>}>
          <CurrencyFormat value={order.monthlyAmount || 0} currency={order.currency} />
        </Descriptions.Item>
      )}
      <Descriptions.Item label={(
        <>
          <b>Total</b>
          {' '}
          (Excluding applicable VAT)
        </>
      )}
      >
        <CurrencyFormat value={calculatedOrder.amount ?? 0} currency={order.currency} />
      </Descriptions.Item>
    </Descriptions>
  );
};

export default Order;
